import {INewsService, INewsItem} from './news.types';
import {ICmsApi} from '../api/cms-api.service';

export default class NewsListController {
  static $inject = ['newsService', 'cmsApi', '$translate'];

  latestNews:INewsItem[];
  announcementsCmsContent: string

  constructor(
    private newsService:INewsService,
  ) {
    this.loadNews();
  }

  private loadNews() {
    this.newsService.getLatestNews().then((latestNews) => {
      this.latestNews = latestNews;
    });
  }
}



/** WEBPACK FOOTER **
 ** ./app/news/news.controller.ts
 **/